/* eslint-disable prettier/prettier */

import { useCallback, useState } from 'react';

import {
	azureFileService,
	DownloadedAzureFile,
} from '../services/azureFile.service';

interface UseAzureFileDownloadReturn {
	downloadFile: (
		fileId: string
	) => Promise<DownloadedAzureFile | null>;

	downloading: boolean;
	error: string | null;
}

export const useAzureFileDownload =
	(): UseAzureFileDownloadReturn => {
		const [downloading, setDownloading] =
			useState(false);

		const [error, setError] =
			useState<string | null>(null);

		const downloadFile = useCallback(
			async (
				fileId: string
			): Promise<DownloadedAzureFile | null> => {
				if (!fileId) {
					setError('File ID is required.');
					return null;
				}

				try {
					setDownloading(true);
					setError(null);

					const response =
						await azureFileService.downloadFile(
							fileId
						);

					return response;
				} catch (err: any) {
					console.error(
						'[useAzureFileDownload] Download failed:',
						err
					);

					setError(
						err?.message ||
							'Failed to download file.'
					);

					return null;
				} finally {
					setDownloading(false);
				}
			},
			[]
		);

		return {
			downloadFile,
			downloading,
			error,
		};
	};